module.exports = __webpack_public_path__ + "img/close_up.4b6ecb44.png";